'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function () {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
exports.__esModule = true;
exports.Slot =
  exports.resetPlugins =
  exports.PluginsConsumer =
  exports.createPlugin =
  exports.ArraySlot =
  exports.onStateChange =
  exports.loadPlugins =
  exports.getPlugins =
  exports.getPluginContext =
  exports.enablePlugin =
    void 0;
var ui_plugin_1 = require('ui-plugin');
__createBinding(exports, ui_plugin_1, 'enablePlugin');
__createBinding(exports, ui_plugin_1, 'getPluginContext');
__createBinding(exports, ui_plugin_1, 'getPlugins');
__createBinding(exports, ui_plugin_1, 'loadPlugins');
__createBinding(exports, ui_plugin_1, 'onStateChange');
var ArraySlot_1 = require('./ArraySlot');
__createBinding(exports, ArraySlot_1, 'ArraySlot');
var createPlugin_1 = require('./createPlugin');
__createBinding(exports, createPlugin_1, 'createPlugin');
var PluginsConsumer_1 = require('./PluginsConsumer');
__createBinding(exports, PluginsConsumer_1, 'PluginsConsumer');
var pluginStore_1 = require('./pluginStore');
__createBinding(exports, pluginStore_1, 'resetPlugins');
var Slot_1 = require('./Slot');
__createBinding(exports, Slot_1, 'Slot');
